import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { PlaceholderPage } from "Shared/Pages/PlaceholderPage";

export const PrivacyPolicyPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <PlaceholderPage
      title={t(Resources.Legal.PrivacyPolicy.Title)}
      body={t(Resources.Legal.Body)}
    />
  );
};
